<div>
  <div>Share:</div>
  <div>
    <a [href]="facebookShareUrl" target="_blank">
      <img
        src="assets/social-facebook.svg"
        width="128"
        height="128"
        alt="Share on Facebook"
      />
    </a>
    <a [href]="whatsappShareUrl" target="_blank">
      <img
        src="assets/social-whatsapp.svg"
        width="128"
        height="128"
        alt="Share on Whatsapp"
      />
    </a>
    <a [href]="telegramShareUrl" target="_blank">
      <img
        src="assets/social-telegram.svg"
        width="128"
        height="128"
        alt="Share on Telegram"
      />
    </a>
  </div>
</div>
